// Recommendation is to ignore message but current test suite checks agains the
// message so keep it for now.
export default function assert(condition, message) {
  if (!condition) {
    throw new Error(message || 'luma.gl: assertion failed.');
  }
}
//# sourceMappingURL=assert.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/utils/assert.js
// module id = 16
// module chunks = 0